import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const viewportHeight = window.innerHeight;
      setIsVisible(scrollPosition > viewportHeight * 0.5);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden">
      <Link
        to="/inscricao"
        className="block bg-gold-500 text-white text-center py-5 font-bold text-lg shadow-2xl rounded-t-3xl hover:bg-gold-400 transition-colors whitespace-nowrap"
      >
        Quero me inscrever
      </Link>
    </div>
  );
}
